import React, { useContext, useEffect, useRef, useState } from "react";
import { PortalContext } from "../../../context/Provider";
import { useHistory } from "react-router";
import {
  wsGetVerificaEstudios,
  wsPostTurnosEstudios,
  logoutEstudiosTurnos,
} from "../../../context/Actions/turnos/estudioTurnos";
import {
  logoutConsultaMedTurnos,
  wsGetVerificaConsultaMedica,
  wsPostConsultaMedTurnos,
} from "../../../context/Actions/turnos/consultaMedTurnos";
import {
  ESTUDIOTURNOS_LOADING,
  CONSULTAMEDTURNOS_LOADING,
} from "../../../context/ActionTypes";
import {
  crearDispatchPropio,
  consumirRespuestaPropia,
} from "../../../../global/helpers/respuestaPropia";
import { showToaster } from "../../../../global/context/action/toaster/toaster";
import { showModal, hideModal } from "../../../context/Actions/modal/modal";
import {
  editaTurnosDisponibles,
  setFechaTurno,
} from "../../../context/Actions/turnos/turnosDisponibles";
import { IonSpinner } from "@ionic/react";
import fechaTurnoFormat from "../../../../global/utils/fechaTurnoFormat";
import Dropdown from "../../Genericos/Dropdown/Dropdown";
import DatePicker from "../../Genericos/DatePicker/DatePicker";
import "./BuscadorConsultaMedica.css";
import { dropdownFamiliares } from "../ListaFamiliaresDropdown/ListaFamiliaresDropdown";
import { GlobalContext } from "../../../../global/context/Provider";
import InputV1 from "../../Genericos/InputV1/InputV1";
import PresentismoBox from "../PresentismoBox/PresentismoBox";
import {
  resetPresentismo,
  wsGetPresentismoDetalle,
} from "_+_Portal/context/Actions/presentismo/presentismo";
import DropdownV2 from "_+_Portal/components/Genericos/DropdownV2/DropdownV2";
import { setUsuarioAuth } from "global/context/action/auth/login";
import { SelectUserGlobal } from "_+_Portal/context/Actions/DropDownFamiliares/selectFamiliares";
import { wsGetDatosPaciente } from "_+_Portal/context/Actions/paciente/paciente";
import SelectDropdown from "_+_Portal/components/Genericos/SelectDropdown/SelectDropdown";

const BuscadorConsultaMedica = ({
  onChangeMultitabMobile,
  buscadorTurnos,
  itemBusqueda,
  busquedaAuto,
}) => {
  const history = useHistory();

  const {
    estudioGrupoState,
    estudioTurnosDispatch,
    estudioTurnosState,
    modalDispatch,
    consultaMedTurnosDispatch,
    consultaMedTurnosState,
    turnosDisponiblesDispatch,
    turnosDisponiblesState,
    listaFamiliaresState,
    selectDropDownState,
    textosState,
    presentismoDispatch,
    presentismoState,
    selectDropDownDispatch,
    pacienteDispatch,
  } = useContext(PortalContext);

  // Cambio de contexto
  const { authState, authDispatch, toasterDispatch, configState } =
    useContext(GlobalContext);

  // Pedidos propios en vuelo sobre los reducers compartidos estudioTurnos y
  // consultaMedTurnos. Ionic mantiene montadas las páginas anteriores, así que
  // puede haber otra instancia de este buscador (u otro buscador) escuchando el
  // mismo reducer: solo la instancia que disparó el pedido procesa la respuesta.
  // Ver global/helpers/respuestaPropia.js.
  const pedidosEstudiosPropios = useRef(0);
  const pedidosConsultaPropios = useRef(0);
  const estudioTurnosDispatchPropio = crearDispatchPropio(
    estudioTurnosDispatch,
    pedidosEstudiosPropios,
    ESTUDIOTURNOS_LOADING,
  );
  const consultaMedTurnosDispatchPropio = crearDispatchPropio(
    consultaMedTurnosDispatch,
    pedidosConsultaPropios,
    CONSULTAMEDTURNOS_LOADING,
  );

  // Información para el date picker
  const fechaLimte = new Date();
  const days = 90;
  fechaLimte.setDate(fechaLimte.getDate() + days);

  const [onChangeVc, setOnChangeVc] = useState(false);
  const [onChangePres, setOnChangePres] = useState(true);
  const [idEstudio, setIdEstudio] = useState("");
  const [descEstudio, setDescEstudio] = useState("");
  const [especialidad, setEspecialidad] = useState("");
  const [medico, setMedico] = useState("");
  const [descEspecialidad, setDescEspecialidad] = useState("");
  const [fecha, setFecha] = useState();
  const [flgEstudioParticular, setFlgEstudioParticular] = useState(false);
  const [flgEspecialidadPart, setFlgEspecialidadPart] = useState(false);
  const [flgEspecialidadOk, setFlgEspecialidadOk] = useState(false);
  const [flgEstudioOk, setFlgEstudioOk] = useState(false);
  const [flgModal, setFlgModal] = useState(false);
  const [determinaciones, setDeterminaciones] = useState();
  const [dtoBusqEstudioDefault, setDtoBusqEstudioDefault] = useState();
  const [dtoPOST, setDtoPOST] = useState(false);
  const [flgDobleVerif, setDobleVerif] = useState(false);
  const [errorDropdown, setErrorDropdown] = useState(false);
  const [pacienteSeleccionado, setPacienteSeleccionado] = useState();
  const [user, setUser] = useState(authState);
  const [OSAlternativa, setOSAlternativa] = useState(false);

  let config = localStorage.getItem("config");
  let portalCem = JSON.parse(config).portal;
  let bloqueoPresentismo = JSON.parse(config).opcBloqueoPresentismo;
  let accion = sessionStorage.getItem("accionHash");
  const widthWindow = window.innerWidth;
  const esMobile = widthWindow <= 768;

  useEffect(() => {
    if (selectDropDownState.selectDropDown.selectGlobal.pacienteElegido) {
      // es el paciente completo
      setUser({
        auth: {
          data: selectDropDownState.selectDropDown.selectGlobal.pacienteElegido,
        },
      });
    } else {
      setUser(authState);
    }
  }, [selectDropDownState.selectDropDown.selectGlobal.pacienteElegido]);

  const dissmiss = () => {
    hideModal()(modalDispatch);
    resetPresentismo()(presentismoDispatch);
  };

  const onChangeDatePicker = (e) => {
    setFecha(e);
    setFechaTurno(e)(turnosDisponiblesDispatch);
  };

  // Nuevo useEffect para el nuevo buscador, cuando presiono en uno de los
  // mas buscados hago la busqueda del turno directamente
  useEffect(() => {
    if (itemBusqueda !== null && itemBusqueda !== undefined) {
      onChangeBuscador(itemBusqueda);
      setFecha(fechaTurnoFormat());
    }
  }, [itemBusqueda]);

  // Este solo se ejecuta en caso de estar en la app, y seleccionar uno de los turnos
  // mas buscados, la busqueda se iniciara automaticamente
  useEffect(() => {
    if (
      itemBusqueda !== null &&
      itemBusqueda !== undefined &&
      busquedaAuto &&
      (flgEspecialidadOk || flgEstudioOk)
    ) {
      onBuscarTurnosClick(itemBusqueda);
    }
  }, [itemBusqueda, flgEspecialidadOk, flgEstudioOk]);

  const onChangeBuscador = (e) => {
    setFlgEstudioOk(false);
    setFlgEspecialidadOk(false);
    setFlgModal(false);
    setPacienteSeleccionado(e);
    if (e !== "") {
      if (
        (selectDropDownState.selectDropDown.selectGlobal.pacienteElegido
          ? selectDropDownState.selectDropDown.selectGlobal.pacienteElegido
              .paciente.ausentismo.rankingConsultas === "Rojo"
          : authState.auth.data.paciente.ausentismo.rankingConsultas ===
            "Rojo") &&
        (selectDropDownState.selectDropDown.selectGlobal.pacienteElegido
          ? !selectDropDownState.selectDropDown.selectGlobal.pacienteElegido
              .paciente.seguimiento
          : !authState.auth.data.paciente.seguimiento) &&
        bloqueoPresentismo === true
      ) {
        showModal(
          "Genericos/Mensaje/Mensaje",
          {
            titulo: <span className="rb24b">Atención</span>,
            textoNegrita: (
              <span className="rb18l">
                {textosState?.textos?.data?.msjBloqueoAusentismo?.descripcion}
              </span>
            ),
            dissmiss: dissmiss,
          },
          [
            {
              text: "Cerrar",
              clase: "btn-Mensaje b-latex30 c-latex30 rb16m",
              accion: dissmiss,
            },
          ],
          "centro",
          true,
        )(modalDispatch);
      } else {
        setFlgEstudioParticular(false);
        setFlgEspecialidadPart(false);
        setFlgModal(false);
        setErrorDropdown(false);
        if (e.id !== null && e.id !== undefined && e.id < 0) {
          setEspecialidad(e.especialidad);
          setMedico(e.medico);
          setDescEspecialidad(e.descripcion);
          setIdEstudio("");
          setDescEstudio("");
          // verifica si el paciente tiene esa obra social

          if (selectDropDownState.selectDropDown.selectGlobal.pacienteElegido) {
            wsGetVerificaConsultaMedica(
              e.especialidad,
              e.medico,
              selectDropDownState.selectDropDown.selectGlobal.pacienteElegido
                .id,
            )(consultaMedTurnosDispatchPropio);
            // wsGetDatosPaciente(
            //   selectDropDownState.selectDropDown.selectGlobal.pacienteElegido
            //     .id,
            //   true,
            //   (isCorrect, data) => nextStepVerificaOS(isCorrect, data, e, true)
            // )(pacienteDispatch);
          } else {
            wsGetVerificaConsultaMedica(
              e.especialidad,
              e.medico,
            )(consultaMedTurnosDispatchPropio);
            // wsGetDatosPaciente(-1, true, (isCorrect, data) =>
            //   nextStepVerificaOS(isCorrect, data, e, true)
            // )(pacienteDispatch);
          }
        } else if (e.id !== null && e.id !== undefined && e.id > 0) {
          setMedico("");
          setEspecialidad("");
          setDescEspecialidad("");
          setIdEstudio(e.id);
          setDescEstudio(e.descripcion);
          // Prestación nueva: siempre se verifica con la cobertura (particular=false).
          // flgEstudioParticular acá es el valor viejo del closure: si el paciente venía de
          // "tomar como particular" o cerró el modal con la cruz, llegaba en true y el
          // verificarOS devolvía 200 para una OS dada de baja.
          if (selectDropDownState.selectDropDown.selectGlobal.pacienteElegido) {
            wsGetVerificaEstudios(
              e.id,
              false,
              onChangeVc,
              selectDropDownState.selectDropDown.selectGlobal.pacienteElegido
                .id,
            )(estudioTurnosDispatchPropio);
            // wsGetDatosPaciente(
            //   selectDropDownState.selectDropDown.selectGlobal.pacienteElegido
            //     .id,
            //   true,
            //   (isCorrect, data) => nextStepVerificaOS(isCorrect, data, e, false)
            // )(pacienteDispatch);
          } else {
            wsGetVerificaEstudios(
              e.id,
              false,
              onChangeVc,
            )(estudioTurnosDispatchPropio);
            // wsGetDatosPaciente(-1, true, (isCorrect, data) =>
            //   nextStepVerificaOS(isCorrect, data, e, false)
            // )(pacienteDispatch);
          }
        }
      }
      setErrorDropdown(false);
    } else {
      setFlgEstudioParticular(false);
      setFlgEspecialidadPart(false);
      setFlgModal(false);
      setEspecialidad("");
      setMedico("");
      setDescEspecialidad("");
      setIdEstudio("");
      setDescEstudio("");
    }
  };

  const nextStepVerificaOS = (isCorrect, data, e, consulta) => {
    if (isCorrect) {
      if (selectDropDownState.selectDropDown.selectGlobal.pacienteElegido) {
        SelectUserGlobal({ id: data.codigo, paciente: data })(
          selectDropDownDispatch,
        );
        if (consulta) {
          wsGetVerificaConsultaMedica(
            e.especialidad,
            e.medico,
            data.id,
          )(consultaMedTurnosDispatchPropio);
        } else {
          wsGetVerificaEstudios(
            e.id,
            flgEstudioParticular,
            onChangeVc,
            data.id,
          )(estudioTurnosDispatchPropio);
        }
      } else {
        // Si la OS se cambió procedo a armar el nuevo dto con la os nueva
        if (
          data?.cobertura?.idCoberturaPlan !==
          authState?.auth?.data?.paciente?.idplan
        ) {
          const userDto = {
            ...authState.auth.data,
            paciente: {
              ...authState.auth.data.paciente,
              cobertura: data.cobertura,
              idplan: data.cobertura.idCoberturaPlan,
              idplan_desc: data.cobertura.plan,
              nro_afiliado: data.cobertura.afiliado,
              obra_social: data.cobertura.idCobertura,
              obra_social_desc: data.cobertura.cobertura,
            },
          };
          const osDto = {
            auth: {
              data: {
                ...userDto,
              },
            },
          };
          setUser(osDto);
          setUsuarioAuth(userDto)(authDispatch);
        }
        if (consulta) {
          wsGetVerificaConsultaMedica(
            e.especialidad,
            e.medico,
          )(consultaMedTurnosDispatchPropio);
        } else {
          wsGetVerificaEstudios(
            e.id,
            flgEstudioParticular,
            onChangeVc,
          )(estudioTurnosDispatchPropio);
        }
      }
    } else {
      showToaster(
        {
          texto: data?.detail || "Error al obtener los datos del paciente",
          tipo: "danger",
        },
        "centroArriba",
      )(toasterDispatch);
    }
  };

  // reemplace radio por check por la dificultad de marcar 1 si o no en un check
  const onChangeRadio = (e) => {
    // let usuario = Object.assign({}, registroState.registro.usuario);
    if (e.target.value === "true") {
      setOnChangePres(true);
      setOnChangeVc(false);
      setFlgEstudioParticular(false);
      setDobleVerif(true);
    } else {
      setOnChangePres(false);
      setOnChangeVc(true);
      setFlgEstudioParticular(false);
      setDobleVerif(true);
    }
  };

  useEffect(() => {
    if (flgDobleVerif) {
      if (medico !== "" && especialidad !== "" && descEspecialidad !== "") {
        setIdEstudio("");
        setDescEstudio("");
        setFlgEstudioParticular(false);
        setFlgEspecialidadOk(false);
        // verica si el paciente tiene obra social
        if (selectDropDownState.selectDropDown.selectGlobal.pacienteElegido) {
          wsGetVerificaConsultaMedica(
            especialidad,
            medico,
            selectDropDownState.selectDropDown.selectGlobal.pacienteElegido.id,
          )(consultaMedTurnosDispatchPropio);
        } else {
          wsGetVerificaConsultaMedica(
            especialidad,
            medico,
          )(consultaMedTurnosDispatchPropio);
        }
        setDobleVerif(false);
      } else if (idEstudio !== "" && descEstudio !== "") {
        setMedico("");
        setEspecialidad("");
        setDescEspecialidad("");
        if (selectDropDownState.selectDropDown.selectGlobal.pacienteElegido) {
          wsGetVerificaEstudios(
            idEstudio,
            flgEstudioParticular,
            onChangeVc,
            selectDropDownState.selectDropDown.selectGlobal.pacienteElegido.id,
          )(estudioTurnosDispatchPropio);
        } else {
          wsGetVerificaEstudios(
            idEstudio,
            flgEstudioParticular,
            onChangeVc,
          )(estudioTurnosDispatchPropio);
        }
        setDobleVerif(false);
      }
    }
  }, [flgDobleVerif]);

  const onBuscarTurnosClick = (pacienteSeleccionado) => {
    if (
      (selectDropDownState.selectDropDown.selectGlobal.pacienteElegido
        ? selectDropDownState.selectDropDown.selectGlobal.pacienteElegido
            .paciente.ausentismo.rankingConsultas === "Rojo"
        : authState.auth.data.paciente.ausentismo.rankingConsultas ===
          "Rojo") &&
      (selectDropDownState.selectDropDown.selectGlobal.pacienteElegido
        ? !selectDropDownState.selectDropDown.selectGlobal.pacienteElegido
            .paciente.seguimiento
        : !authState.auth.data.paciente.seguimiento) &&
      bloqueoPresentismo === true
    ) {
      showModal(
        "Genericos/Mensaje/Mensaje",
        {
          titulo: <span className="rb24b">Atención</span>,
          textoNegrita: (
            <span className="rb18l">
              {textosState?.textos?.data?.msjBloqueoAusentismo?.descripcion}
            </span>
          ),
          dissmiss: dissmiss,
        },
        [
          {
            text: "Cerrar",
            clase: "btn-Mensaje b-latex30 c-latex30 rb16m",
            accion: dissmiss,
          },
        ],
        "centro",
        true,
      )(modalDispatch);
    } else {
      // CAMBIE EL IF QUE NO DEJABA BUSCAR POR ESPECIALIDAD, YA ARROJA ERROR SI EL CAMPO ESTA VACIO
      if (pacienteSeleccionado !== "" && pacienteSeleccionado !== undefined) {
        if (!flgModal) {
          // funcion para obtener la fecha formateada en caso de necesitarla para la busqueda
          if (flgEspecialidadOk) {
            setDtoPOST({
              especialidad: especialidad,
              medico: medico,
              fecha: fecha,
              flgEspecialidadPart: flgEspecialidadPart,
              videoConsulta: onChangeVc,
              videoAtencion: onChangeVc,
              OsAlternativa: OSAlternativa ? OSAlternativa : false,
            });
            if (
              selectDropDownState.selectDropDown.selectGlobal.pacienteElegido
            ) {
              wsPostConsultaMedTurnos(
                especialidad,
                medico,
                fecha,
                flgEspecialidadPart,
                onChangeVc,
                selectDropDownState.selectDropDown.selectGlobal.pacienteElegido
                  .id,
              )(consultaMedTurnosDispatchPropio);
            } else {
              wsPostConsultaMedTurnos(
                especialidad,
                medico,
                fecha,
                flgEspecialidadPart,
                onChangeVc,
                -1,
                OSAlternativa ? OSAlternativa : false,
              )(consultaMedTurnosDispatchPropio);
            }
            setFlgEspecialidadOk(false);
          } else if (flgEstudioOk) {
            setDtoBusqEstudioDefault({
              ...dtoBusqEstudioDefault,
              amamantando: false,
              conContraste: false, ////lo obtengo de seleccionar el item especialidad o estudio
              contrasteReciente: false,
              diabeticoHipertenso: false,
              embarazada: false,
              fechaDesde: fecha, //fecha esta en datepicker,
              GruposMedico: [
                {
                  Id: idEstudio,
                  Descripcion: descEstudio,
                  Particular: flgEstudioParticular,
                },
              ],
              idGrupoMedico: idEstudio, //lo obtengo de seleccionar el item especialidad o estudio
              idObraSocial: user.auth.data.paciente.obra_social
                ? user.auth.data.paciente.obra_social
                : user.auth.data.paciente.obraSocial,
              idPlan: user.auth.data.paciente.idplan
                ? user.auth.data.paciente.idplan
                : user.auth.data.paciente.idPlan,
              insRenal: false,
              marcapasos: false,
              operador: accion ? "BOT" : "",
              pag: 1200, //hardcodeado en angular
              particular: flgEstudioParticular, //lo obtengo de seleccionar el check
              pesoSuperior: false,
              pesoSuperiorCritico: false,
              rec: 0, //harcodeado en angularionic
              videoAtencion: onChangeVc, //lo lleno por con el checkbox
              OsAlternativa: OSAlternativa ? OSAlternativa : false,
            });
          }
        } else {
          // le consulto nuevamente si lo quiere tomar como part.
          if (flgEspecialidadOk) {
            if (
              selectDropDownState.selectDropDown.selectGlobal.pacienteElegido
            ) {
              wsGetVerificaConsultaMedica(
                especialidad,
                medico,
                selectDropDownState.selectDropDown.selectGlobal.pacienteElegido
                  .id,
              )(consultaMedTurnosDispatchPropio);
            } else {
              wsGetVerificaConsultaMedica(
                especialidad,
                medico,
              )(consultaMedTurnosDispatchPropio);
            }
          } else if (flgEstudioOk) {
            // Re-verificación con la cobertura y con el formato elegido (video o presencial).
            if (
              selectDropDownState.selectDropDown.selectGlobal.pacienteElegido
            ) {
              wsGetVerificaEstudios(
                idEstudio,
                false,
                onChangeVc,
                selectDropDownState.selectDropDown.selectGlobal.pacienteElegido
                  .id,
              )(estudioTurnosDispatchPropio);
            } else {
              wsGetVerificaEstudios(
                idEstudio,
                false,
                onChangeVc,
              )(estudioTurnosDispatchPropio);
            }
          }
        }
      } else {
        setErrorDropdown(true);
      }
    }
  };

  //agrego lo de cambio de fecha en consulta medica.
  const verificaCambioFecha = () => {
    let objBusqDefault = Object.assign({}, dtoBusqEstudioDefault);
    if (fecha !== null) {
      objBusqDefault.fechaDesde = fecha;
    } else if (
      turnosDisponiblesState.turnosDisponibles.turnosData.fechaSeleccionada
    ) {
      objBusqDefault.fechaDesde =
        turnosDisponiblesState.turnosDisponibles.turnosData.fechaSeleccionada;
    }
    return objBusqDefault;
  };

  const cancelaParticular = () => {
    dissmiss();
    logoutEstudiosTurnos()(estudioTurnosDispatchPropio);
    logoutConsultaMedTurnos()(consultaMedTurnosDispatchPropio);
    setFlgEspecialidadPart(false);
    setFlgEstudioParticular(false);
    // setFlgEstudioOk(false);
    // setFlgEspecialidadOk(false);
    // setFlgModal(false);
  };

  const cancelaAlternativa = () => {
    dissmiss();
    logoutEstudiosTurnos()(estudioTurnosDispatchPropio);
    logoutConsultaMedTurnos()(consultaMedTurnosDispatchPropio);
    setOSAlternativa(false);
    setFlgEstudioOk(false);
    setFlgEspecialidadOk(false);
    setFlgModal(false);
  };

  const deterComoParticular = () => {
    dissmiss();
    setFlgModal(false);
    logoutEstudiosTurnos()(estudioTurnosDispatchPropio);
    logoutConsultaMedTurnos()(consultaMedTurnosDispatchPropio);
  };

  const modalParticular = (descripcion, tipo) => {
    const esConsulta = tipo === "consulta";
    showModal(
      "Genericos/Mensaje/Mensaje",
      {
        titulo: esConsulta
          ? "La obra social no cubre la consulta"
          : "La obra social no cubre el estudio",
        textoNegrita: "¿Deseás tomar el turno como particular?",
        texto:
          descripcion && descripcion !== ""
            ? descripcion
            : esConsulta
              ? "La consulta con el profesional seleccionado no figura dentro de tu cobertura"
              : "El estudio seleccionado no figura dentro de tu cobertura",
        // La cruz equivale a "Cancelar": si solo cerrara el modal, flgEstudioParticular
        // quedaba en true y la próxima prestación se verificaba como particular.
        dissmiss: cancelaParticular,
      },
      [
        {
          text: "Cancelar",
          clase: "btn-Mensaje b-latex30 c-latex30 rb16m",
          accion: cancelaParticular,
        },
        {
          text: "Tomar como particular",
          clase: "btn-Mensaje-1 rb16m bgc-latex10 c-white",
          accion: deterComoParticular,
        },
      ],
      "centro",
      true, // bloquearDissmiss: el fondo no cierra sin pasar por un botón
    )(modalDispatch);
  };

  const modalOSAlternativa = () => {
    showModal(
      "Genericos/Mensaje/Mensaje",
      {
        titulo: "La obra social no cubre el estudio",
        textoNegrita: "¿Deseás tomar el turno con tu obra social alternativa?",
        texto: "La determinacion seleccionada no figura dentro de tu cobertura",
        dissmiss: cancelaAlternativa,
      },
      [
        {
          text: "Cancelar",
          clase: "btn-Mensaje b-latex30 c-latex30 rb16m",
          accion: cancelaAlternativa,
        },
        {
          text: "Tomar con OS alternativa",
          clase: "btn-Mensaje-1 rb16m bgc-latex10 c-white",
          accion: deterComoParticular,
        },
      ],
      "centro",
      true,
    )(modalDispatch);
  };

  const modalAtencionSinTurnoPrevio = () => {
    showModal(
      "Genericos/Mensaje/Mensaje",
      {
        titulo: "El estudio se realiza sin turno previo",
        textoNegrita: "Prueba",
        texto: "a Definir",
        dissmiss: dissmiss,
        danger: true,
      },
      [
        {
          text: "Salir",
          clase: "btn-Mensaje-1 rb16m bgc-latex10 c-white",
          accion: dissmiss,
        },
        {
          text: "Leer sobre turnos sin reserva",
          clase: "btn-Mensaje-1 rb16m bgc-latex30 c-white",
          accion: dissmiss,
        },
      ],
      "centro",
    )(modalDispatch);
  };

  useEffect(() => {
    if (dtoBusqEstudioDefault !== undefined) {
      let objBusqueda = verificaCambioFecha();
      setDtoPOST(objBusqueda);
      if (selectDropDownState.selectDropDown.selectGlobal.pacienteElegido) {
        wsPostTurnosEstudios(
          objBusqueda,
          selectDropDownState.selectDropDown.selectGlobal.pacienteElegido.id,
        )(estudioTurnosDispatchPropio);
      } else {
        wsPostTurnosEstudios(objBusqueda)(estudioTurnosDispatchPropio);
      }
      setDtoBusqEstudioDefault(undefined);
      //por ahora part no
      // setFlgParticular(false);
    }
  }, [dtoBusqEstudioDefault]);

  useEffect(() => {
    // Respuesta de otra instancia, o dato viejo mientras corre un pedido nuevo:
    // no procesar. Una instancia "virgen" pisaba turnosDisponibles con
    // GruposMedico[].Id = "" y dtoBusqueda = false, y la toma fallaba con 400.
    if (
      !consumirRespuestaPropia(
        estudioTurnosState.estudioTurnos,
        pedidosEstudiosPropios,
      )
    ) {
      return;
    }
    if (
      estudioTurnosState.estudioTurnos.data !== undefined &&
      estudioTurnosState.estudioTurnos.data !== null &&
      estudioTurnosState.estudioTurnos.data !== false &&
      estudioTurnosState.estudioTurnos.data !== ""
    ) {
      if (
        estudioTurnosState.estudioTurnos.data.continua &&
        estudioTurnosState.estudioTurnos.data.circuito === ""
      ) {
        setFlgEstudioOk(true);
        setFlgEspecialidadOk(false);
        logoutEstudiosTurnos()(estudioTurnosDispatchPropio);
      } else if (
        estudioTurnosState.estudioTurnos.data.turnos !== null &&
        estudioTurnosState.estudioTurnos.data.turnos !== undefined &&
        estudioTurnosState.estudioTurnos.data.turnos !== ""
      ) {
        editaTurnosDisponibles({
          ...turnosDisponiblesState.turnosDisponibles.turnosData,
          turnos: estudioTurnosState.estudioTurnos.data.turnos,
          GruposMedico: [
            {
              Id: idEstudio,
              Descripcion: descEstudio,
              Particular: flgEstudioParticular,
            },
          ],
          particular: flgEstudioParticular,
          idEstudio: idEstudio,
          descEstudio: descEstudio,
          descEspecialidad: null,
          fechaBusqueda: estudioTurnosState.estudioTurnos.data.fechaBusqueda,
          dtoBusqueda: dtoPOST,
          volverOrigen: "CONSULTA_MEDICA",
          proceso: "estudios",
        })(turnosDisponiblesDispatch);
        setFlgEstudioParticular(false);
        history.push("/turnosDisponibles");
      } else if (estudioTurnosState.estudioTurnos.data.codigo === 9) {
        setFlgEstudioParticular(true);
        setFlgEstudioOk(true);
        setFlgModal(true);
        setFlgEspecialidadOk(false);
        modalParticular(estudioTurnosState.estudioTurnos.data.mensaje, "estudio");
        logoutEstudiosTurnos()(estudioTurnosDispatchPropio);
      } else if (estudioTurnosState.estudioTurnos.data.codigo === 8) {
        showModal(
          "Genericos/Mensaje/Mensaje",
          {
            titulo: "Atención",
            texto: (
              <div
                dangerouslySetInnerHTML={{
                  __html: estudioTurnosState.estudioTurnos.data.mensaje,
                }}
              ></div>
            ),
            dissmiss: dissmiss,
            danger: true,
          },
          [
            {
              text: "Volver",
              clase: "btn-Mensaje b-latex30 c-latex30 rb16m",
              accion: cancelaParticular,
            },
          ],
          "centro",
        )(modalDispatch);
        setFlgEspecialidadOk(false);
        logoutEstudiosTurnos()(estudioTurnosDispatchPropio);
      } else if (estudioTurnosState.estudioTurnos.data.codigo === 91) {
        setOSAlternativa(true);
        setFlgEstudioOk(true);
        setFlgModal(true);
        setFlgEspecialidadOk(false);
        modalOSAlternativa();
        logoutEstudiosTurnos()(estudioTurnosDispatchPropio);
      } else if (estudioTurnosState.estudioTurnos.data.codigo === 10) {
        modalAtencionSinTurnoPrevio();
        logoutEstudiosTurnos()(estudioTurnosDispatchPropio);
      } else if (
        estudioTurnosState.estudioTurnos.data.codigo === 0 &&
        !estudioTurnosState.estudioTurnos.data.continua &&
        estudioTurnosState.estudioTurnos.data.mensaje
      ) {
        // Caso especial: código 0 con mensaje (antes era 400, ahora es 200)
        const mensaje = estudioTurnosState.estudioTurnos.data.mensaje;
        if (mensaje.length > 100) {
          showModal(
            "Genericos/Mensaje/Mensaje",
            {
              titulo: "Atención",
              texto: (
                <div
                  dangerouslySetInnerHTML={{
                    __html: mensaje,
                  }}
                ></div>
              ),
              dissmiss: dissmiss,
              danger: true,
            },
            [
              {
                text: "Volver",
                clase: "btn-Mensaje b-latex30 c-latex30 rb16m",
                accion: cancelaParticular,
              },
            ],
            "centro",
          )(modalDispatch);
        } else {
          showToaster(
            {
              texto: mensaje,
              tipo: "danger",
            },
            "centroArriba",
          )(toasterDispatch);
        }
        setFlgEspecialidadOk(false);
        setFlgEstudioOk(false);
        logoutEstudiosTurnos()(estudioTurnosDispatchPropio);
      } else if (estudioTurnosState.estudioTurnos.data.codigo) {
        showToaster(
          {
            texto: estudioTurnosState.estudioTurnos.data.mensaje,
            tipo: "danger",
          },
          "centroArriba",
        )(toasterDispatch);
        logoutEstudiosTurnos()(estudioTurnosDispatchPropio);
      } else {
        showToaster(
          {
            texto: "Ha ocurrido un error",
            tipo: "danger",
          },
          "centroArriba",
        )(toasterDispatch);
        logoutEstudiosTurnos()(estudioTurnosDispatchPropio);
      }
    } else if (
      estudioTurnosState.estudioTurnos.error?.detail !== "" &&
      estudioTurnosState.estudioTurnos.error?.detail !== null &&
      estudioTurnosState.estudioTurnos.error?.detail !== undefined
    ) {
      // Verificar si el error contiene un código específico (9, 10, 91, 8, etc.)
      if (estudioTurnosState.estudioTurnos.error?.detail?.codigo) {
        const errorCodigo =
          estudioTurnosState.estudioTurnos.error.detail.codigo;

        if (errorCodigo === 9) {
          setFlgEstudioParticular(true);
          setFlgEstudioOk(true);
          setFlgModal(true);
          setFlgEspecialidadOk(false);
          modalParticular(estudioTurnosState.estudioTurnos.error?.mensaje, "estudio");
          logoutEstudiosTurnos()(estudioTurnosDispatchPropio);
        } else if (errorCodigo === 8) {
          const mensaje =
            estudioTurnosState.estudioTurnos.error.mensaje ||
            estudioTurnosState.estudioTurnos.error.detail;
          showModal(
            "Genericos/Mensaje/Mensaje",
            {
              titulo: "Atención",
              texto: (
                <div
                  dangerouslySetInnerHTML={{
                    __html: mensaje,
                  }}
                ></div>
              ),
              dissmiss: dissmiss,
              danger: true,
            },
            [
              {
                text: "Volver",
                clase: "btn-Mensaje b-latex30 c-latex30 rb16m",
                accion: cancelaParticular,
              },
            ],
            "centro",
          )(modalDispatch);
          setFlgEspecialidadOk(false);
          logoutEstudiosTurnos()(estudioTurnosDispatchPropio);
        } else if (errorCodigo === 91) {
          setOSAlternativa(true);
          setFlgEstudioOk(true);
          setFlgModal(true);
          setFlgEspecialidadOk(false);
          modalOSAlternativa();
          logoutEstudiosTurnos()(estudioTurnosDispatchPropio);
        } else if (errorCodigo === 10) {
          modalAtencionSinTurnoPrevio();
          logoutEstudiosTurnos()(estudioTurnosDispatchPropio);
        } else if (errorCodigo === 0) {
          // Caso especial: código 0 con mensaje
          const mensaje =
            estudioTurnosState.estudioTurnos.error.mensaje ||
            estudioTurnosState.estudioTurnos.error.detail;
          if (mensaje && mensaje.length > 100) {
            showModal(
              "Genericos/Mensaje/Mensaje",
              {
                titulo: "Atención",
                texto: (
                  <div
                    dangerouslySetInnerHTML={{
                      __html: mensaje,
                    }}
                  ></div>
                ),
                dissmiss: dissmiss,
                danger: true,
              },
              [
                {
                  text: "Volver",
                  clase: "btn-Mensaje b-latex30 c-latex30 rb16m",
                  accion: cancelaParticular,
                },
              ],
              "centro",
            )(modalDispatch);
          } else {
            showToaster(
              {
                texto: mensaje,
                tipo: "danger",
              },
              "centroArriba",
            )(toasterDispatch);
          }
          setFlgEspecialidadOk(false);
          setFlgEstudioOk(false);
          logoutEstudiosTurnos()(estudioTurnosDispatchPropio);
        } else {
          // Otros códigos de error específicos
          const mensaje =
            estudioTurnosState.estudioTurnos.error.mensaje ||
            estudioTurnosState.estudioTurnos.error.detail;

          if (mensaje && mensaje.length > 100) {
            showModal(
              "Genericos/Mensaje/Mensaje",
              {
                titulo: <p className="rb18b">Información</p>,
                textoNegrita: (
                  <p
                    className="rb18l"
                    dangerouslySetInnerHTML={{
                      __html: mensaje,
                    }}
                  ></p>
                ),
                danger: true,
                dissmiss: dissmiss,
              },
              [
                {
                  text: "Aceptar",
                  clase: "btn-Mensaje b-latex30 c-latex30 rb16m",
                  accion: dissmiss,
                },
              ],
              "centro",
              true,
            )(modalDispatch);
          } else {
            showToaster(
              {
                texto: mensaje,
                tipo: "danger",
              },
              "centroArriba",
            )(toasterDispatch);
          }
          logoutEstudiosTurnos()(estudioTurnosDispatchPropio);
        }
      } else if (
        estudioTurnosState.estudioTurnos.error.detail !== "" &&
        estudioTurnosState.estudioTurnos.error.detail !== null &&
        estudioTurnosState.estudioTurnos.error.detail !== undefined
      ) {
        // Manejo genérico de errores con detail
        if (
          estudioTurnosState.estudioTurnos.error?.mensaje &&
          estudioTurnosState.estudioTurnos.error?.mensaje?.length > 100
        ) {
          showModal(
            "Genericos/Mensaje/Mensaje",
            {
              titulo: "Atención",
              texto: (
                <div
                  dangerouslySetInnerHTML={{
                    __html: estudioTurnosState.estudioTurnos?.error?.mensaje,
                  }}
                ></div>
              ),
              dissmiss: dissmiss,
              danger: true,
            },
            [
              {
                text: "Volver",
                clase: "btn-Mensaje b-latex30 c-latex30 rb16m",
                accion: cancelaParticular,
              },
            ],
            "centro",
          )(modalDispatch);
          logoutEstudiosTurnos()(estudioTurnosDispatchPropio);
        } else if (
          typeof estudioTurnosState.estudioTurnos.error.detail === "string" &&
          estudioTurnosState.estudioTurnos.error.detail.length > 100
        ) {
          showModal(
            "Genericos/Mensaje/Mensaje",
            {
              titulo: "Atención",
              texto: (
                <div
                  dangerouslySetInnerHTML={{
                    __html: estudioTurnosState.estudioTurnos.error.detail,
                  }}
                ></div>
              ),
              dissmiss: dissmiss,
              danger: true,
            },
            [
              {
                text: "Volver",
                clase: "btn-Mensaje b-latex30 c-latex30 rb16m",
                accion: cancelaParticular,
              },
            ],
            "centro",
          )(modalDispatch);
          logoutEstudiosTurnos()(estudioTurnosDispatchPropio);
        } else {
          const mensajeError =
            estudioTurnosState.estudioTurnos.error.detail?.mensaje ||
            estudioTurnosState.estudioTurnos.error.detail;
          showToaster(
            {
              texto:
                typeof mensajeError === "string" ? (
                  <div
                    dangerouslySetInnerHTML={{
                      __html: mensajeError,
                    }}
                  ></div>
                ) : (
                  "Ha ocurrido un error"
                ),
              tipo: "danger",
            },
            "centroArriba",
          )(toasterDispatch);
          logoutEstudiosTurnos()(estudioTurnosDispatchPropio);
        }
      } else {
        showToaster(
          {
            texto:
              estudioTurnosState.estudioTurnos.error?.mensaje ||
              (typeof estudioTurnosState.estudioTurnos.error?.detail ===
              "string"
                ? estudioTurnosState.estudioTurnos.error.detail
                : "Ha ocurrido un error"),
            tipo: "danger",
          },
          "centroArriba",
        )(toasterDispatch);
        logoutEstudiosTurnos()(estudioTurnosDispatchPropio);
      }
    }
  }, [estudioTurnosState]);

  useEffect(() => {
    // Mismo candado que en estudioTurnos: solo la instancia que pidió procesa.
    if (
      !consumirRespuestaPropia(
        consultaMedTurnosState.consultaMedTurnos,
        pedidosConsultaPropios,
      )
    ) {
      return;
    }
    if (
      consultaMedTurnosState.consultaMedTurnos.data !== undefined &&
      consultaMedTurnosState.consultaMedTurnos.data !== null &&
      consultaMedTurnosState.consultaMedTurnos.data !== false &&
      consultaMedTurnosState.consultaMedTurnos.data !== ""
    ) {
      if (
        consultaMedTurnosState.consultaMedTurnos.data.continua &&
        consultaMedTurnosState.consultaMedTurnos.data.circuito === null &&
        consultaMedTurnosState.consultaMedTurnos.data.codigo === 0
      ) {
        setFlgEspecialidadOk(true);
        setFlgEstudioOk(false);
        logoutConsultaMedTurnos()(consultaMedTurnosDispatchPropio);
      } else if (
        !consultaMedTurnosState.consultaMedTurnos.data.continua &&
        consultaMedTurnosState.consultaMedTurnos.data.circuito === null &&
        consultaMedTurnosState.consultaMedTurnos.data.codigo === 1
      ) {
        showToaster(
          {
            texto: consultaMedTurnosState.consultaMedTurnos.data.mensaje,
            tipo: "danger",
          },
          "centroArriba",
        )(toasterDispatch);
        setFlgEspecialidadOk(false);
        logoutConsultaMedTurnos()(consultaMedTurnosDispatchPropio);
      } else if (
        !consultaMedTurnosState.consultaMedTurnos.data.continua &&
        consultaMedTurnosState.consultaMedTurnos.data.circuito === null &&
        consultaMedTurnosState.consultaMedTurnos.data.codigo === 3
      ) {
        showToaster(
          {
            texto: consultaMedTurnosState.consultaMedTurnos.data.mensaje,
            tipo: "danger",
          },
          "centroArriba",
        )(toasterDispatch);
        setFlgEspecialidadOk(false);
        logoutConsultaMedTurnos()(consultaMedTurnosDispatchPropio);
      } else if (
        !consultaMedTurnosState.consultaMedTurnos.data.continua &&
        consultaMedTurnosState.consultaMedTurnos.data.circuito === null &&
        consultaMedTurnosState.consultaMedTurnos.data.codigo === 5
      ) {
        setFlgEspecialidadOk(false);
        showToaster(
          {
            texto: consultaMedTurnosState.consultaMedTurnos.data.mensaje,
            tipo: "danger",
          },
          "centroArriba",
        )(toasterDispatch);
        logoutConsultaMedTurnos()(consultaMedTurnosDispatchPropio);
      } else if (
        !consultaMedTurnosState.consultaMedTurnos.data.continua &&
        consultaMedTurnosState.consultaMedTurnos.data.circuito === null &&
        consultaMedTurnosState.consultaMedTurnos.data.codigo === 6
      ) {
        setFlgEspecialidadOk(false);
        showToaster(
          {
            texto: consultaMedTurnosState.consultaMedTurnos.data.mensaje,
            tipo: "danger",
          },
          "centroArriba",
        )(toasterDispatch);
        logoutConsultaMedTurnos()(consultaMedTurnosDispatchPropio);
      } else if (
        !consultaMedTurnosState.consultaMedTurnos.data.continua &&
        consultaMedTurnosState.consultaMedTurnos.data.circuito === null &&
        consultaMedTurnosState.consultaMedTurnos.data.codigo === 7
      ) {
        setFlgEspecialidadOk(false);
        showToaster(
          {
            texto: consultaMedTurnosState.consultaMedTurnos.data.mensaje,
            tipo: "danger",
          },
          "centroArriba",
        )(toasterDispatch);
        logoutConsultaMedTurnos()(consultaMedTurnosDispatchPropio);
      } else if (
        !consultaMedTurnosState.consultaMedTurnos.data.continua &&
        consultaMedTurnosState.consultaMedTurnos.data.circuito === null &&
        consultaMedTurnosState.consultaMedTurnos.data.codigo === 8
      ) {
        setFlgEspecialidadOk(false);
        showToaster(
          {
            texto: consultaMedTurnosState.consultaMedTurnos.data.mensaje,
            tipo: "danger",
          },
          "centroArriba",
        )(toasterDispatch);
        logoutConsultaMedTurnos()(consultaMedTurnosDispatchPropio);
      } else if (
        !consultaMedTurnosState.consultaMedTurnos.data.continua &&
        consultaMedTurnosState.consultaMedTurnos.data.circuito === null &&
        consultaMedTurnosState.consultaMedTurnos.data.codigo === 9
      ) {
        setFlgEspecialidadPart(true);
        setFlgEspecialidadOk(true);
        setFlgModal(true);
        setFlgEstudioOk(false);
        modalParticular(consultaMedTurnosState.consultaMedTurnos.data?.mensaje, "consulta");
        logoutConsultaMedTurnos()(consultaMedTurnosDispatchPropio);
      } else if (
        !consultaMedTurnosState.consultaMedTurnos.data.continua &&
        consultaMedTurnosState.consultaMedTurnos.data.circuito === null &&
        consultaMedTurnosState.consultaMedTurnos.data.codigo === 91
      ) {
        setOSAlternativa(true);
        setFlgEspecialidadOk(true);
        setFlgModal(true);
        setFlgEstudioOk(false);
        modalOSAlternativa();
        logoutConsultaMedTurnos()(consultaMedTurnosDispatchPropio);
      } else if (
        consultaMedTurnosState.consultaMedTurnos.data.data.length >= 0
      ) {
        editaTurnosDisponibles({
          ...turnosDisponiblesState.turnosDisponibles.turnosData,
          turnos: consultaMedTurnosState.consultaMedTurnos.data.data,
          grupoMedico: null,
          particular: flgEspecialidadPart,
          idEstudio: null,
          descEstudio: null,
          descEspecialidad: descEspecialidad,
          fechaBusqueda:
            consultaMedTurnosState.consultaMedTurnos.data.fechaBusqueda,
          dtoBusqueda: dtoPOST,
          volverOrigen: "CONSULTA_MEDICA",
          proceso: "consMedica",
        })(turnosDisponiblesDispatch);
        history.push("/turnosDisponibles");
      }
    } else if (
      consultaMedTurnosState.consultaMedTurnos.error !== null &&
      consultaMedTurnosState.consultaMedTurnos.error !== undefined &&
      consultaMedTurnosState.consultaMedTurnos.error !== false
    ) {
      if (consultaMedTurnosState.consultaMedTurnos.error.detail === "9") {
        setFlgEspecialidadPart(true);
        modalParticular(undefined, "consulta");
        logoutConsultaMedTurnos()(consultaMedTurnosDispatchPropio);
      } else if (
        consultaMedTurnosState.consultaMedTurnos.error.detail === "10"
      ) {
        modalAtencionSinTurnoPrevio();
        logoutConsultaMedTurnos()(consultaMedTurnosDispatchPropio);
      } else if (
        consultaMedTurnosState.consultaMedTurnos.error.detail === "91"
      ) {
        modalOSAlternativa();
        setOSAlternativa(true);
        logoutConsultaMedTurnos()(consultaMedTurnosDispatchPropio);
      } else {
        if (
          consultaMedTurnosState.consultaMedTurnos.error.detail !== "" &&
          consultaMedTurnosState.consultaMedTurnos.error.detail !== null &&
          consultaMedTurnosState.consultaMedTurnos.error.detail !== undefined
        ) {
          if (
            consultaMedTurnosState.consultaMedTurnos.error.detail.length > 100
          ) {
            showModal(
              "Genericos/Mensaje/Mensaje",
              {
                titulo: "Requiere autorización",
                texto: (
                  <div
                    dangerouslySetInnerHTML={{
                      __html:
                        consultaMedTurnosState.consultaMedTurnos.error.detail,
                    }}
                  ></div>
                ),
                dissmiss: dissmiss,
                danger: true,
              },
              [
                {
                  text: "Volver",
                  clase: "btn-Mensaje b-latex30 c-latex30 rb16m",
                  accion: cancelaParticular,
                },
              ],
              "centro",
            )(modalDispatch);
            logoutConsultaMedTurnos()(consultaMedTurnosDispatchPropio);
          } else {
            showToaster(
              {
                texto: (
                  <div
                    dangerouslySetInnerHTML={{
                      __html:
                        consultaMedTurnosState.consultaMedTurnos.error.detail,
                    }}
                  ></div>
                ),
                tipo: "danger",
              },
              "centroArriba",
            )(toasterDispatch);
            logoutConsultaMedTurnos()(consultaMedTurnosDispatchPropio);
          }
        } else {
          showToaster(
            {
              texto: consultaMedTurnosState.consultaMedTurnos.error,
              tipo: "danger",
            },
            "centroArriba",
          )(toasterDispatch);
          logoutConsultaMedTurnos()(consultaMedTurnosDispatchPropio);
        }
      }
    }
  }, [consultaMedTurnosState]);

  //agrego logica volver a verificar estudio/consMed por cambio de paciente.
  useEffect(() => {
    if (selectDropDownState.selectDropDown.selectGlobal.pacienteElegido) {
      setFlgEstudioParticular(false);
      setFlgEspecialidadPart(false);
      setFlgModal(false);
      // deberia preguntar primero si busque algo. aca usamos idestudio.
      if (especialidad !== "" && medico) {
        wsGetVerificaConsultaMedica(
          especialidad,
          medico,
          selectDropDownState.selectDropDown.selectGlobal.pacienteElegido.id,
        )(consultaMedTurnosDispatchPropio);
      } else if (idEstudio !== "" && descEstudio !== "") {
        // Cambio de paciente: se verifica con la cobertura, no con el flag viejo del closure.
        wsGetVerificaEstudios(
          idEstudio,
          false,
          onChangeVc,
          selectDropDownState.selectDropDown.selectGlobal.pacienteElegido.id,
        )(estudioTurnosDispatchPropio);
      }
    } else {
      if (
        (especialidad !== "" && medico !== "") ||
        (idEstudio !== "" && descEstudio !== "")
      ) {
        setFlgEstudioParticular(false);
        setFlgEspecialidadPart(false);
        setFlgModal(false);
        if (especialidad !== "" && medico !== "") {
          wsGetVerificaConsultaMedica(
            especialidad,
            medico,
          )(consultaMedTurnosDispatchPropio);
        } else if (idEstudio !== "" && descEstudio !== "") {
          wsGetVerificaEstudios(
            idEstudio,
            false,
            onChangeVc,
          )(estudioTurnosDispatchPropio);
        }
      }
    }
  }, [selectDropDownState.selectDropDown.selectGlobal]);

  useEffect(() => {
    if (estudioGrupoState.estudioGrupo.data !== null) {
      const arrGrupoMed = estudioGrupoState.estudioGrupo.data.filter(
        (item) =>
          item.sonPracticas === false &&
          item.idCircuito !== "RMN" &&
          item.idCircuito !== "TOMO",
      );
      const grupoMed = arrGrupoMed.filter((item) => item.id > 0);
      const agenda = arrGrupoMed.filter((item) => item.id < 0);
      const turnosCompletos = grupoMed.concat(agenda);
      let filt = turnosCompletos.sort((a, b) => {
        return b.cantBusquedas - a.cantBusquedas;
      });
      setDeterminaciones(filt);
      setFecha(fechaTurnoFormat());
    }
    //me aseguro que siempre se limpien los turnos disponibles
    // finalizaTurnosDisponibles()(turnosDisponiblesDispatch);
  }, []);

  // Busca el dia de hoy para el datePicker
  const hoyDia = new Date();
  const noventaDiasDespues = new Date();
  noventaDiasDespues.setDate(noventaDiasDespues.getDate() + 90);

  const modalTurnosPresentismo = () => {
    if (selectDropDownState.selectDropDown.selectGlobal.pacienteElegido) {
      wsGetPresentismoDetalle(
        true,
        selectDropDownState.selectDropDown.selectGlobal.pacienteElegido.id,
      )(presentismoDispatch);
    } else {
      wsGetPresentismoDetalle(true, false)(presentismoDispatch);
    }
  };

  useEffect(() => {
    if (presentismoState.presentismo.data !== null) {
      showModal(
        "Turnos/ModalPresentismo/ModalPresentismo",
        {
          dissmiss: dissmiss,
          danger: true,
        },
        [],
        "centro",
        true,
      )(modalDispatch);
    }
  }, [presentismoState.presentismo.data]);

  const modalInfoPresentismo = () => {
    showModal(
      "Genericos/Mensaje/Mensaje",
      {
        titulo: <span className="rb24b">Información</span>,
        textoNegrita: (
          <span
            className="rb18l explicacionPresentismo"
            dangerouslySetInnerHTML={{
              __html:
                textosState?.textos?.data?.msjPresentismoAyuda?.descripcion,
            }}
          ></span>
        ),
        dissmiss: dissmiss,
      },
      [
        {
          text: "Aceptar",
          clase: "btn-Mensaje b-latex30 c-latex30 rb16m",
          accion: dissmiss,
        },
      ],
      "centro",
      true,
    )(modalDispatch);
  };
  const [test, setTest] = useState(1);

  const configDropdown = {
    data: determinaciones,
    ordenPersonalizado: true,
    autoFocus: true,
    header: buscadorTurnos ? "" : "Busca por especialidad o profesional",
    headerColor: buscadorTurnos && "c-white",
    footer: "Busca una especialidad o profesional",
    descripcion: "descripcion",
    placeholder: textosState.textos.data?.txtConsultaMedica?.descripcion,
    placeHolderFontSize: 16,
    defaultValue:
      itemBusqueda !== null && itemBusqueda !== undefined
        ? itemBusqueda.descripcion
        : test,
    defaultValueParametro: "descripcion",
    height: 38,
    cantidadItems: 10,
    maxlength: 100,
    error: false,
    arrow: true,
    search: false,
    disabled: false,
    tooltip: false,
    showUp: true,
    regex: /^[a-zA-Z\s]+$/,
    masBuscados: configState.config.data.opcMasBuscados,
    itemBusqueda: itemBusqueda,
    buscarPorDefault: true,
  };

  return (
    <React.Fragment>
      {!buscadorTurnos && (
        <>
          <div className="ptur-buscadorConsulta-desktop-dropdown">
            <SelectDropdown
              data={dropdownFamiliares(
                listaFamiliaresState,
                authState,
                "ManejoTurnos",
              )}
              descripcion={"nombre"}
              placeholder={"Seleccionar Familiar"}
              onChangeInput={onChangeMultitabMobile}
              selectedValue={
                selectDropDownState.selectDropDown.selectGlobal.pacienteElegido
                  ? selectDropDownState.selectDropDown.selectGlobal
                      .pacienteElegido.paciente
                  : authState.auth.data.paciente
              }
              styles={{
                width: esMobile && "100%",
              }}
            />
            {bloqueoPresentismo && (
              <PresentismoBox
                consultas={true}
                modalInfoPresentismo={modalInfoPresentismo}
                modalTurnosPresentismo={modalTurnosPresentismo}
              />
            )}
          </div>
        </>
      )}

      <div
        className={
          !buscadorTurnos
            ? "cuerpoPestaniaConsulta"
            : "cuerpoPestaniaConsultaBuscadorTurnos"
        }
      >
        <div
          className={
            buscadorTurnos
              ? "ptur-buscadorConsultaTurnos-dropdown"
              : "ptur-buscadorConsulta-dropdown"
          }
        >
          <DropdownV2 config={configDropdown} onClick={onChangeBuscador} />
        </div>
        <div className="ptur-buscadorConsultaMedica-checkbox-boton">
          <div className="ptur-buscadorConsultaMedica-checkbox-container">
            {portalCem === "cemedic" ? (
              <div className="ptur-buscador-checkbox-consultaMedica-general">
                <div className="ptur-buscador-checkbox-consultaMedica">
                  <InputV1
                    inputType="hidden"
                    labelStr="Presencial"
                    labelColor={buscadorTurnos && "c-white"}
                    nombreRadio="formato"
                    name="checkpresencial"
                    onChange={onChangeRadio}
                    value={true}
                    checked
                  />
                </div>
              </div>
            ) : (
              <>
                <div className="ptur-buscador-titulo-checkbox-consultaMedica">
                  <span className={`${buscadorTurnos && "c-white"} rb14m`}>
                    Formato
                  </span>
                </div>
                <div className="ptur-buscador-checkbox-consultaMedica-general">
                  <div className="ptur-buscador-checkbox-consultaMedica">
                    <InputV1
                      inputType="radio"
                      labelStr="Presencial"
                      labelColor={buscadorTurnos && "c-white"}
                      nombreRadio="formato"
                      name="checkpresencial"
                      onChange={onChangeRadio}
                      value={true}
                      checked
                    />
                  </div>
                  <div className="ptur-buscador-checkbox-consultaMedica">
                    <InputV1
                      inputType="radio"
                      labelStr="Video llamada"
                      labelColor={buscadorTurnos && "c-white"}
                      nombreRadio="formato"
                      name="checkvideollamada"
                      onChange={onChangeRadio}
                      value={false}
                    />
                  </div>
                </div>
              </>
            )}
          </div>
          <div className="ptur-buscadorConsulta-boton-fecha">
            <div className="ptur-buscadorConsulta-fecha">
              <DatePicker
                fechaInicial={`${hoyDia.getFullYear()} ${
                  hoyDia.getMonth() + 1
                } ${hoyDia.getDate()}`}
                fechaFinal={`${noventaDiasDespues.getFullYear()} ${
                  noventaDiasDespues.getMonth() + 1
                } ${noventaDiasDespues.getDate()}`}
                headerStr={"Buscar fecha"}
                headerStrColor={buscadorTurnos && "c-white"}
                // fechaMin={hoy}
                onChange={onChangeDatePicker}
                customCss="ptur-datePciker-consultaMedica"
              />
            </div>
            <div className="ptur-buscadorConsulta-boton-container">
              <button
                onClick={() => onBuscarTurnosClick(pacienteSeleccionado)}
                className={`ptur-consulta-botonSiguiente bgc-primary c-white rb18m`}
                disabled={
                  estudioTurnosState.estudioTurnos.loading ||
                  consultaMedTurnosState.consultaMedTurnos.loading
                }
              >
                {estudioTurnosState.estudioTurnos.loading ||
                consultaMedTurnosState.consultaMedTurnos.loading ? (
                  <span className="ptur-buscadorConsulta-loading">
                    <IonSpinner name="lines-small" />
                  </span>
                ) : (
                  "Siguiente"
                )}
              </button>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default BuscadorConsultaMedica;
